import { DestroyRef, Directive, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OrderDirection } from '@zero/shared/util-models';
import { TradeFacade } from '@zero/trade/domain';
import { filter } from 'rxjs';

@Directive()
export class MultiOrderBaseComponent {
  public readonly facade = inject(TradeFacade);
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  protected destroyRef = inject(DestroyRef);

  public route = MultiOrderRoutes.CREATE;
  public readonly ROUTES = MultiOrderRoutes;

  protected readonly listenToQueryParams = () => {
    this.#route.queryParams.pipe(filter((params) => !!params['isin'])).subscribe(({ isin, qty, direction }) => {
      this.#extractInstrumentsFromUrl(isin, qty, direction);
    });

    this.#router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.facade.clearMultiOrder();
        this.route = MultiOrderRoutes.CREATE;
      }
    });
  };

  readonly #extractInstrumentsFromUrl = (isin: string, qty: string, direction: string) => {
    const separator = ',';
    this.facade.addMultiOrderInstruments(
      isin
        .split(separator)
        .map((isin: string, i: number) => ({
          isin: isin ? isin.trim() : '',
          qty: qty ? Number(qty.split(separator)[i]?.trim()) : null,
          direction: direction ? (direction.split(separator)[i]?.trim() as OrderDirection) : 'buy',
        }))
        .filter(({ isin }) => isin.length === 12),
    );
  };
}

export enum MultiOrderRoutes {
  CREATE,
  CONFIRM,
  SUCCESS,
}
